const loadingLabel = "Betöltés";
const huHU = {
  loadingLabel
};
export {
  huHU as default,
  loadingLabel
};
